function KeyIcon() {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.8125 3.25C11.3672 3.25 8.625 6.02734 8.625 9.4375C8.625 9.96484 8.69531 10.457 8.80078 10.9492L3.31641 16.4336C3.10547 16.6445 3 16.9258 3 17.2422V20.6875C3 21.0039 3.24609 21.25 3.5625 21.25H6.9375C7.21875 21.25 7.5 21.0039 7.5 20.6875V19H9.1875C9.46875 19 9.75 18.7539 9.75 18.4375V16.75H11.7539C11.8945 16.75 12.0352 16.7148 12.1406 16.6094L13.3008 15.4492C13.793 15.5547 14.2852 15.625 14.8125 15.625C18.2227 15.625 21 12.8477 21 9.4375C21 5.99219 18.2227 3.25 14.8125 3.25ZM16.2188 9.4375C15.4102 9.4375 14.8125 8.83984 14.8125 8.03125C14.8125 7.25781 15.4102 6.625 16.2188 6.625C16.9922 6.625 17.625 7.25781 17.625 8.03125C17.625 8.83984 16.9922 9.4375 16.2188 9.4375Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default KeyIcon;
